import type { ColDef, GridOptions } from 'ag-grid-enterprise';

import type { AlertRuleDTO } from '@/pages/AlertRules/AlertRules.types';
import {
  checkMarkRenderer,
  dateTimeRenderer,
  idRenderer,
  textRenderer
} from '@/utils/GridRenderer.utils';

export const ALERT_RULES_COLUMN_DEFS: ColDef<AlertRuleDTO>[] = [
  {
    cellRenderer: idRenderer,
    cellRendererParams: {
      colorAnchor: true
    },
    field: 'id',
    headerName: 'ID',
    headerTooltip: 'ID',
    sortable: true,
    width: 80
  },
  {
    field: 'name',
    cellRenderer: textRenderer,
    headerName: 'Name',
    headerTooltip: 'Name',
    sortable: true,
    flex: 1
  },
  {
    field: 'repo',
    cellRenderer: textRenderer,
    headerName: 'Repo',
    headerTooltip: 'Repo',
    sortable: true,
    width: 180
  },
  // TODO: Add triggered count back when available in the API
  // {
  //   field: 'triggered_count',
  //   cellRenderer: textRenderer,
  //   headerName: 'Triggered Count',
  //   headerTooltip: 'Triggered Count',
  //   sortable: true,
  //   width: 150
  // },
  {
    field: 'enabled',
    cellClass: 'ag-cell-center',
    cellRenderer: checkMarkRenderer,
    headerName: 'Alerting',
    headerClass: 'ag-header-center',
    headerTooltip: 'Alerting Enabled (Logscale)',
    sortable: true,
    width: 90
  },
  {
    field: 'ai_enabled',
    cellClass: 'ag-cell-center',
    cellRenderer: checkMarkRenderer,
    headerName: 'AI Analysis',
    headerClass: 'ag-header-center',
    headerTooltip: 'AI Analysis Enabled',
    sortable: true,
    width: 120
  },
  {
    field: 'ai_escalation',
    cellClass: 'ag-cell-center',
    cellRenderer: checkMarkRenderer,
    headerName: 'AI Escalation',
    headerClass: 'ag-header-center',
    headerTooltip: 'AI Escalation (Ticketing) Enabled',
    sortable: true,
    width: 120
  },
  {
    cellRenderer: dateTimeRenderer,
    field: 'last_triggered_at',
    headerName: 'Last Triggered',
    headerTooltip: 'Last Triggered',
    sortable: true,
    width: 160
  },
  {
    cellRenderer: dateTimeRenderer,
    field: 'updated_at',
    headerName: 'Last Modified',
    headerTooltip: 'Last Modified',
    sortable: true,
    width: 160
  }
];

export const ALERT_RULES_GRID_OPTIONS: GridOptions = {
  animateRows: false,
  defaultColDef: {
    resizable: true,
    sortable: true,
    suppressHeaderMenuButton: true
  },
  rowSelection: {
    mode: 'singleRow',
    checkboxes: false,
    enableClickSelection: false
  },
  pagination: true,
  paginationPageSize: 20,
  paginationPageSizeSelector: [10, 20, 50, 100],
  rowHeight: 55,
  suppressCellFocus: true,
  suppressMultiSort: true,
  tooltipShowMode: 'whenTruncated',
  suppressContextMenu: true
};
